import { useEffect, useState } from "react";
import api from "@/lib/api";
import { VocePicker } from "@/components/prima_nota/VocePicker";

const PLESSI = ["INFANZIA", "PRIMARIA", "SECONDARIA", "COMUNITA"];
const fmt = n => Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const isoToDmy = iso => { if (!iso || !iso.includes("-")) return ""; const [y,m,d]=iso.split("-"); return `${d}/${m}/${y}`; };
const dmyToIso = dmy => { if (!dmy || !dmy.includes("/")) return ""; const [d,m,y]=dmy.split("/"); return `${y}-${m.padStart(2,"0")}-${d.padStart(2,"0")}`; };

export default function PrimaNotaVociExtraPage() {
  const thisYear = new Date().getFullYear();
  const [anno, setAnno] = useState(thisYear);
  const [plesso, setPlesso] = useState("");
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const [totale, setTotale] = useState(0);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const [showImport, setShowImport] = useState(false);

  const carica = async () => {
    setLoading(true);
    try {
      const params = {};
      if (anno) params.anno = anno;
      if (plesso) params.plesso = plesso;
      if (search) params.search = search;
      const r = await api.get("/pn/costi-extra", { params });
      setList(r.data.data || []);
      setTotale(r.data.totale_importo || 0);
    } catch { /* noop */ }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(); /* eslint-disable-next-line */ }, []);

  const apriNuova = () => setEditing({ _isNew: true, data: "", descrizione: "", importo: 0, plesso: "INFANZIA", conto: null });
  const apriEdit = (r) => setEditing({ ...r });

  const elimina = async (r) => {
    if (!window.confirm(`Eliminare la voce extra "${r.descrizione}" del ${r.data}?`)) return;
    await api.delete(`/pn/costi-extra/${r.id_operazione}/${r.id_riga}`);
    carica();
  };

  return (
    <div>
      <div className="sw-page-title">
        <h1>💰 Voci Extra</h1>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => setShowImport(true)} data-testid="pn-extra-import"
            style={{ padding: "6px 14px", background: "#5d4037", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>📥 Importa Excel</button>
          <button onClick={apriNuova} data-testid="pn-extra-new"
            style={{ padding: "6px 14px", background: "#00838f", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Nuova voce</button>
        </div>
      </div>

      <div style={{ margin: "8px 20px", padding: 10, background: "white", border: "1px solid #ccc", display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap" }}>
        <div>
          <div style={{ fontSize: 11, color: "#666", marginBottom: 3 }}>Anno</div>
          <input type="number" value={anno} onChange={e => setAnno(Number(e.target.value)||"")} data-testid="pn-extra-anno"
            style={{ width: 90, padding: "4px 8px", border: "1px solid #ccc", fontSize: 12 }} />
        </div>
        <div>
          <div style={{ fontSize: 11, color: "#666", marginBottom: 3 }}>Plesso</div>
          <select value={plesso} onChange={e => setPlesso(e.target.value)} data-testid="pn-extra-plesso"
            style={{ padding: "4px 8px", border: "1px solid #ccc", fontSize: 12 }}>
            <option value="">Tutti</option>
            {PLESSI.map(p => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>
        <div style={{ flex: "1 1 250px" }}>
          <div style={{ fontSize: 11, color: "#666", marginBottom: 3 }}>Cerca descrizione</div>
          <input type="text" value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key==="Enter" && carica()} data-testid="pn-extra-search"
            style={{ width: "100%", padding: "4px 8px", border: "1px solid #ccc", fontSize: 12 }} />
        </div>
        <button onClick={carica} disabled={loading}
          style={{ padding: "6px 16px", background: "#00695c", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>{loading ? "..." : "↻ Aggiorna"}</button>
        <div style={{ marginLeft: "auto", fontSize: 12, color: "#444", display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
          <div><b>{list.length}</b> voci</div>
          <div style={{ fontFamily: "monospace", fontSize: 13, color: "#00695c", fontWeight: 700 }}>Σ € {fmt(totale)}</div>
        </div>
      </div>

      <div style={{ margin: "0 20px 20px", background: "white", border: "1px solid #ccc", maxHeight: "70vh", overflow: "auto" }}>
        <table className="sw-table sw-table-compact" style={{ fontSize: 11 }}>
          <thead style={{ position: "sticky", top: 0, background: "#37474f", color: "white", zIndex: 1 }}>
            <tr>
              <th style={{ width: 32 }}>#</th>
              <th style={{ width: 70 }}>OP / RG</th>
              <th style={{ width: 95 }}>DATA</th>
              <th style={{ minWidth: 280 }}>DESCRIZIONE</th>
              <th style={{ width: 60, textAlign: "center" }}>CONTO</th>
              <th style={{ minWidth: 200 }}>VOCE BILANCIO</th>
              <th style={{ width: 110 }}>PLESSO</th>
              <th style={{ width: 110, textAlign: "right" }}>IMPORTO €</th>
              <th style={{ width: 110, textAlign: "center" }}>AZIONI</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={9} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessuna voce extra.</td></tr>}
            {list.map((r, i) => (
              <tr key={`${r.id_operazione}-${r.id_riga}`} data-testid={`pn-extra-row-${i}`}>
                <td style={{ textAlign: "center", color: "#888", fontFamily: "monospace" }}>{i+1}</td>
                <td style={{ fontFamily: "monospace", fontSize: 10, color: "#888" }}>{r.id_operazione}/{r.id_riga}</td>
                <td style={{ fontFamily: "monospace" }}>{r.data || "—"}</td>
                <td>{r.descrizione || <span style={{ color: "#bbb" }}>—</span>}</td>
                <td style={{ textAlign: "center", fontFamily: "monospace", color: "#00838f", fontWeight: 700 }}>{r.conto ?? "—"}</td>
                <td style={{ fontSize: 10, color: "#555" }}>{r.descrizione_conto || <span style={{ color: "#bbb" }}>—</span>}</td>
                <td style={{ fontWeight: 700, color: "#0d47a1" }}>{r.plesso || "—"}</td>
                <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>{fmt(r.importo)}</td>
                <td style={{ textAlign: "center" }}>
                  <button onClick={() => apriEdit(r)} data-testid={`pn-extra-edit-${i}`}
                    style={{ padding: "2px 8px", background: "#1565c0", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 3 }}>✏</button>
                  <button onClick={() => elimina(r)} data-testid={`pn-extra-del-${i}`}
                    style={{ padding: "2px 8px", background: "white", color: "#c62828", border: "1px solid #c62828", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && <VoceExtraEditor v={editing} onClose={() => { setEditing(null); carica(); }} />}
      {showImport && <ImportExtraModal onClose={() => { setShowImport(false); carica(); }} />}
    </div>
  );
}

function VoceExtraEditor({ v, onClose }) {
  const [doc, setDoc] = useState(v);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);
  const [voci, setVoci] = useState([]);
  const [pickerOpen, setPickerOpen] = useState(false);

  useEffect(() => {
    api.get("/pn/bilancio-voci").then(r => setVoci(r.data.data || []));
  }, []);

  const isNew = !!doc._isNew;
  const set = (k, val) => setDoc(d => ({ ...d, [k]: val }));

  const voceSel = voci.find(x => x.id_conto === Number(doc.conto));
  const codeOf = (x) => x ? (x.c1 == null ? `${x.c0}` : (!x.is_foglia ? `${x.c0}.${x.c1}` : `${x.c0}.${x.c1}.${x.c3}`)) : "";

  const salva = async () => {
    if (!doc.data) { setErr("Data obbligatoria"); return; }
    if (!doc.plesso) { setErr("Plesso obbligatorio"); return; }
    setSaving(true); setErr(null);
    try {
      const body = {
        data: doc.data,
        descrizione: doc.descrizione || "",
        importo: Number(doc.importo || 0),
        plesso: doc.plesso || null,
        conto: doc.conto != null && doc.conto !== "" ? Number(doc.conto) : null,
      };
      if (isNew) {
        await api.post("/pn/costi-extra", body);
      } else {
        await api.put(`/pn/costi-extra/${doc.id_operazione}/${doc.id_riga}`, body);
      }
      onClose();
    } catch (e) { setErr(e.response?.data?.detail || "Errore salvataggio"); }
    finally { setSaving(false); }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} data-testid="pn-extra-editor"
        style={{ background: "white", width: 720, maxHeight: "90vh", display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#00838f", color: "white", padding: "6px 12px", display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontWeight: 700, fontSize: 13 }}>{isNew ? "+ Nuova voce extra" : `✏ Voce ${doc.id_operazione}/${doc.id_riga}`}</span>
          <span style={{ flex: 1 }} />
          <button onClick={onClose} style={{ padding: "3px 10px", background: "white", color: "#00838f", border: "none", fontWeight: 700, cursor: "pointer" }}>✕ Chiudi</button>
        </div>
        {err && <div style={{ padding: 8, background: "#fff0f0", color: "#c00", fontSize: 12 }}>{err}</div>}
        <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 10, flex: 1, overflow: "auto" }}>
          <div style={{ display: "flex", gap: 12 }}>
            <div style={{ flex: 1 }}>
              <Lab>DATA</Lab>
              <input type="date" value={dmyToIso(doc.data || "")} onChange={e => set("data", isoToDmy(e.target.value))} data-testid="pn-extra-data"
                style={{ width: "100%", padding: "5px 8px", border: "1px solid #888", fontSize: 12 }} />
            </div>
            <div style={{ flex: 1 }}>
              <Lab>PLESSO</Lab>
              <select value={doc.plesso || ""} onChange={e => set("plesso", e.target.value)} data-testid="pn-extra-edit-plesso"
                style={{ width: "100%", padding: "5px 8px", border: "1px solid #888", fontSize: 12 }}>
                {PLESSI.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <Lab>IMPORTO €</Lab>
              <input type="number" value={doc.importo} onChange={e => set("importo", e.target.value)} data-testid="pn-extra-importo"
                style={{ width: "100%", padding: "5px 8px", border: "1px solid #888", fontSize: 14, fontFamily: "monospace", fontWeight: 700, textAlign: "right" }} />
            </div>
          </div>
          <div>
            <Lab>DESCRIZIONE</Lab>
            <input type="text" value={doc.descrizione || ""} onChange={e => set("descrizione", e.target.value)} data-testid="pn-extra-desc"
              style={{ width: "100%", padding: "5px 8px", border: "1px solid #888", fontSize: 12 }} />
          </div>
          <div>
            <Lab>VOCE DI BILANCIO</Lab>
            <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
              <button type="button" onClick={() => setPickerOpen(true)} data-testid="pn-extra-voce-pick"
                style={{ padding: "6px 14px", background: "#1565c0", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                {voceSel ? "↻ Cambia voce" : "📂 Seleziona voce"}
              </button>
              {voceSel
                ? <span data-testid="pn-extra-voce-sel" style={{ fontSize: 12, fontWeight: 700, color: "#00695c" }}><span style={{ fontFamily: "monospace", color: "#1565c0" }}>{codeOf(voceSel)}</span> · {voceSel.descrizione} <span style={{ color: "#aaa" }}>(COD {voceSel.id_conto})</span></span>
                : <span style={{ fontSize: 12, color: "#999" }}>Nessuna voce selezionata</span>}
            </div>
          </div>
        </div>
        <div style={{ padding: 8, background: "#fafafa", display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ padding: "5px 14px", background: "white", border: "1px solid #555", cursor: "pointer" }}>Annulla</button>
          <button onClick={salva} disabled={saving} data-testid="pn-extra-save"
            style={{ padding: "5px 14px", background: "#00838f", color: "white", border: "none", fontWeight: 700, cursor: "pointer" }}>
            {saving ? "..." : "💾 Salva"}
          </button>
        </div>
      </div>
      <VocePicker open={pickerOpen} value={doc.conto} onClose={() => setPickerOpen(false)}
        onSelect={v => { set("conto", v.id_conto); setPickerOpen(false); }} />
    </div>
  );
}

function ImportExtraModal({ onClose }) {
  const [url, setUrl] = useState("");
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);
  const [err, setErr] = useState(null);
  const importa = async () => {
    if (!url.trim()) { setErr("URL Excel obbligatorio"); return; }
    setImporting(true); setErr(null); setResult(null);
    try {
      const r = await api.post("/pn/costi-extra/import-append", { url: url.trim() });
      setResult(r.data);
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setImporting(false); }
  };
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} data-testid="pn-extra-import-modal" style={{ background: "white", width: 600 }}>
        <div style={{ background: "#5d4037", color: "white", padding: "6px 12px", fontWeight: 700 }}>📥 Importa Excel Voci Extra (append)</div>
        <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 8 }}>
          {err && <div style={{ padding: 6, background: "#fff0f0", color: "#c00", fontSize: 11 }}>{err}</div>}
          {result && <div style={{ padding: 6, background: "#e8f5e9", color: "#1b5e20", fontSize: 11 }}>✓ Importate <b>{result.imported}</b> nuove righe.</div>}
          <div style={{ fontSize: 11, color: "#555", lineHeight: 1.5 }}>
            URL del file <b>.xlsx</b> contenente le colonne: <code>Data</code>, <code>Descrizione</code>, <code>Importo</code>, <code>Plesso</code>, <code>Conto</code>.
            <br />Le righe verranno <b>aggiunte</b> ai dati esistenti (no overwrite).
          </div>
          <input type="url" value={url} onChange={e => setUrl(e.target.value)} data-testid="pn-extra-import-url"
            placeholder="https://customer-assets.emergentagent.com/.../voci-extra.xlsx"
            style={{ padding: "6px 10px", border: "1px solid #888", fontSize: 12 }} />
        </div>
        <div style={{ padding: 8, background: "#fafafa", display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ padding: "5px 14px", background: "white", border: "1px solid #555", cursor: "pointer" }}>{result ? "Chiudi" : "Annulla"}</button>
          <button onClick={importa} disabled={importing || !url} data-testid="pn-extra-import-go"
            style={{ padding: "5px 14px", background: "#5d4037", color: "white", border: "none", fontWeight: 700, cursor: importing ? "wait" : "pointer" }}>
            {importing ? "Importazione..." : "📥 Importa"}
          </button>
        </div>
      </div>
    </div>
  );
}

const Lab = ({ children }) => <div style={{ fontSize: 11, fontWeight: 700, color: "#37474f", marginBottom: 3 }}>{children}</div>;
